import { render, staticRenderFns } from "./GPISettings.vue?vue&type=template&id=243bcc5e"
import script from "./GPISettings.vue?vue&type=script&lang=ts"
export * from "./GPISettings.vue?vue&type=script&lang=ts"
import style0 from "./GPISettings.vue?vue&type=style&index=0&id=243bcc5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports